/**
 * โครงสร้างเมนู Sidebar (ไอคอนโมดูลกำหนดใน MainSidebar — SIDEBAR_MODULE_ICONS)
 * access.subMenuAccess[MODULE][href] ควบคุมสิทธิ์เมนูย่อย
 */

/** ชื่อที่แสดงเป็นกลุ่มโมดูล (tooltip แถบหลัก + หัวข้อแถบรอง) */
export const SIDEBAR_MODULE_TITLE = {
  PROFILE: 'ส่วนตัว & โปรไฟล์',
  PROJECT: 'โครงการ',
  HUMEN: 'ทรัพยากรบุคคล',
  FINANCE: 'การเงิน',
  SALE: 'การขาย & เอกสาร',
  CUSTOMER: 'ลูกค้า',
  DIRECTOR: 'ผู้บริหาร',
  MANAGEMENT: 'การตั้งค่าระบบ',
  ACCOUNTING: 'จัดการบัญชีบริษัท',
  MARKETING: 'การตลาด',
};

export const SIDEBAR_NAV_ITEMS = [
  {
    href: '/profile/timestamp',
    title: 'บันทึกเวลา',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/profile/ot',
    title: 'คำขอโอที',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/profile/disbursement',
    title: 'การเบิกจ่าย',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/profile/crl-disbursement',
    title: 'ตั้งเบิก CRL',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/profile/fuel-setting',
    title: 'การตั้งเบิกน้ำมันรถ',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/profile/leave',
    title: 'คำขอลา',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/profile/field-allowance',
    title: 'คำขอค่าออกสนาม',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/project/project',
    title: 'โครงการ',
    name: 'PROJECT',
    sub: [
      { href: '/project/project', title: 'โครงการ' },
      { href: '/project/activity-log', title: 'บันทึกกิจกรรม' },
    ],
  },
  {
    href: '/humen/reportDaily',
    title: 'ทรัพยากรบุคคล',
    name: 'HUMEN',
    sub: [
      { href: '/humen/reportDaily', title: 'บันทึกเวลารายวัน' },
      { href: '/humen/ot-request', title: 'คำขอโอที' },
      { href: '/humen/leave-request', title: 'คำขอลา' },
      { href: '/humen/field-allowance-request', title: 'คำขอค่าออกสนาม' },
      { href: '/humen/salarylist', title: 'เงินเดือน' },
      { href: '/humen/monthly-salary-summary', title: 'รายงานส่งประกันสังคม' },
      { href: '/humen/report', title: 'รายงานรายเดือน' },
      { href: '/humen/hr-report-v2', title: 'สรุปเงินเดือน' },
      { href: '/humen/checkin-management', title: 'จัดการสถานที่ลงเวลา' },
      { href: '/humen/timestamp', title: 'รายการบันทึกเวลา' },
      { href: '/humen/employee', title: 'พนักงาน' },
      { href: '/humen/announcements', title: 'ประกาศ' },
      { href: '/humen/activity-log', title: 'บันทึกกิจกรรม' },
    ],
  },
  {
    href: '/finance/expenses',
    title: 'การเงิน',
    name: 'FINANCE',
    sub: [
      { href: '/finance/expenses', title: 'รายการเบิกเงิน' },
      { href: '/finance/expenses/all', title: 'ดูรายการตั้งเบิกทั้งหมด' },
      { href: '/finance/expenses/recurring', title: 'รายการเบิกประจำ' },
      { href: '/finance/daily-report', title: 'รายงานรายวัน' },
      { href: '/finance/payment', title: 'เตรียมจ่ายเงิน' },
      { href: '/finance/billing', title: 'วางบิล' },
      { href: '/finance/expense-approvers', title: 'ตั้งค่าผู้อนุมัติรายการ' },
      { href: '/finance/summary', title: 'สรุปการเงิน' },
      { href: '/finance/activity-log', title: 'บันทึกกิจกรรม' },
      { href: '/finance/bank-reconciliation', title: 'กระทบยอดธนาคารรายวัน' },
      // ย้ายมาจากกลุ่ม PROFILE (เดิม name:'PROFILE') ตามคำขอ — ยังคงเป็นหน้าใต้ /profile/* เหมือนเดิม
      // (ดู layouts/Profie.js) แค่ให้โชว์ในแท็บเมนู "การเงิน" แทนเพราะเนื้อหาเกี่ยวกับงานการเงินโดยตรง
      // group: 'ส่วนตัว' ทำให้ MainSidebar.js render 2 อันนี้แยกเป็นกล่องมีกรอบต่างหาก ไม่ปนกับ list
      // เรียบๆ ด้านบน (ดู isPaymentApprover/isExpenseReviewer ใน MainSidebar.js ที่ยังซ่อนเมนูพวกนี้
      // จากคนที่ไม่ได้ถูกตั้งเป็นผู้อนุมัติ/ผู้ตรวจสอบไว้เหมือนเดิมทุกประการ ไม่ได้เปลี่ยน logic นั้น)
      {
        href: '/profile/payment-approval',
        title: 'อนุมัติการจ่ายเงิน',
        group: 'ส่วนตัว',
      },
      {
        href: '/profile/expense-review',
        title: 'ตรวจสอบรายการเบิกเงิน',
        group: 'ส่วนตัว',
      },
    ],
  },
  {
    href: '/marketing/opportunities',
    title: 'การตลาด',
    name: 'MARKETING',
    // "เช็กอิน" แสดงให้ทุกคนที่มีสิทธิ์ Marketing เห็นเสมอ (เหมือนเมนูอื่น) — ความสามารถ "เช็กอินได้
    // จริง" ถูกจำกัดแยกต่างหากที่ระดับหน้า/action เท่านั้น: ฝั่ง UI (CheckinPage.js) โชว์แค่
    // opportunity ที่ user เป็น owner_id และ status ยังเปิดอยู่ (WAITING/IN_PROGRESS/ON_HOLD)
    // ฝั่ง backend (services/marketing/controllers/checkin.controller.js) เช็ค owner_id ซ้ำอีกชั้น
    // ก่อนบันทึกเช็คอินจริงเสมอ — ไม่ได้ผูก dynamic visibility ที่เมนูนี้
    sub: [
      { href: '/marketing/opportunities', title: 'โอกาสทางธุรกิจ' },
      { href: '/marketing/checkin', title: 'เช็กอิน' },
    ],
  },
  {
    href: '/sale/documents',
    title: 'การขาย & เอกสาร',
    name: 'SALE',
    sub: [
      { href: '/sale/documents', title: 'ใบเสนอราคา' },
      { href: '/sale/item-templates', title: 'แม่แบบรายการ' },
    ],
  },
  {
    href: '/customer',
    title: 'ลูกค้า',
    name: 'CUSTOMER',
    sub: [
      { href: '/customer/customers', title: 'ลูกค้า', level: 0 },
      { href: '/customer/client', title: 'Client', level: 0 },
      { href: '/customer/suppliers', title: 'Supplier', level: 0 },
      { href: '/customer/customer-types', title: 'ประเภทลูกค้า', level: 1 },
      { href: '/customer/activity-log', title: 'บันทึกกิจกรรม' },
    ],
  },
  {
    href: '/director/project',
    title: 'ผู้บริหาร',
    name: 'DIRECTOR',
    sub: [
      { href: '/director/project', title: 'ภาพรวมโครงการ', level: 0 },
      {
        href: '/director/approve-expenses',
        title: 'อนุมัติจ่ายเงิน',
        level: 0,
      },
    ],
  },
  {
    href: '/profile/profile',
    title: 'โปรไฟล์',
    name: 'PROFILE',
    sub: [],
  },
  {
    href: '/accounting/loan-pairs',
    title: 'จัดการบัญชีบริษัท',
    name: 'ACCOUNTING',
    sub: [
      { href: '/accounting/loan-pairs', title: 'ยืม-คืน' },
      { href: '/accounting/loan-pairs-setup', title: 'ตั้งค่าคู่ยืม-คืน' },
      { href: '/accounting/company-account', title: 'บัญชีบริษัท' },
    ],
  },
  {
    href: '/management/employee',
    title: 'การตั้งค่า',
    name: 'MANAGEMENT',
    sub: [
      { href: '/management/employee', title: 'พนักงาน' },
      { href: '/management/holiday', title: 'วันหยุด' },
      { href: '/management/department', title: 'แผนก' },
      { href: '/management/role-type', title: 'ประเภทบทบาท' },
      { href: '/management/roles', title: 'บทบาท' },
      { href: '/management/user', title: 'ผู้ใช้งาน' },
      { href: '/management/paytype', title: 'ประเภทการจ่ายเงิน' },
      { href: '/management/transection-type', title: 'ประเภทรายการ' },
      { href: '/management/business', title: 'ตั้งค่า' },
      { href: '/management/vehicles', title: 'รายการรถยนต์' },
      { href: '/management/budgets', title: 'งบประมาณ' },
      { href: '/management/menu-visibility', title: 'จัดการเมนู' },
      { href: '/management/approvers', title: 'ตั้งค่าผู้อนุมัติ' },
      { href: '/management/developer', title: 'นักพัฒนา' },
      { href: '/management/activity-log', title: 'บันทึกกิจกรรม' },
    ],
  },
];

/** รายการเมนูย่อยตามโมดูล (สำหรับฟอร์มแผนก) */
export function buildSubmenuEntriesByModule() {
  const by = {};
  SIDEBAR_NAV_ITEMS.forEach((row) => {
    const mod = row.name;
    if (!by[mod]) by[mod] = [];
    if (row.sub?.length) {
      row.sub.forEach((s) => {
        by[mod].push({
          href: s.href,
          title: s.title,
          level: s.level ?? 0,
        });
      });
    } else {
      by[mod].push({ href: row.href, title: row.title, level: 0 });
    }
  });
  return by;
}

export const SUBMENU_ENTRIES_BY_MODULE = buildSubmenuEntriesByModule();

/** เติมค่าเมนูย่อยที่ยังไม่เคยบันทึกเป็น true (รองรับข้อมูลแผนกเก่า) */
export function mergeSubMenuDefaults(access = {}) {
  const existing = access.subMenuAccess || {};
  const out = {};
  Object.keys(SUBMENU_ENTRIES_BY_MODULE).forEach((mod) => {
    out[mod] = { ...(existing[mod] || {}) };
    SUBMENU_ENTRIES_BY_MODULE[mod].forEach(({ href }) => {
      if (out[mod][href] === undefined) out[mod][href] = true;
    });
  });
  return out;
}
